import { render, staticRenderFns } from "./MemberReports.vue?vue&type=template&id=5d846ace&scoped=true&"
import script from "./MemberReports.vue?vue&type=script&lang=js&"
export * from "./MemberReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d846ace",
  null
  
)

export default component.exports